import { Button, styled } from '@mui/material';

export const CreateButton = styled(Button)({
  height: '56px',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
});
